"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIntersection = void 0;
function setIntersection(set1, set2) {
    const s = new Set();
    if (!set1.size || !set2.size) {
        return s;
    }
    set1.forEach(el => {
        if (set2.has(el)) {
            s.add(el);
        }
    });
    return s;
}
exports.setIntersection = setIntersection;
